import type {
  AfriexGroupedProcessorMetrics,
  AfriexProcessorMetricsBucket,
} from '@afriex/core/domain/types';

import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import {formatTime} from '@/screens/Processor/Metrics/utils';

const SubCurrencyTable = ({
  data: groupedByCurrency,
  currency,
}: {
  data: AfriexGroupedProcessorMetrics;
  currency: string;
}) => {
  return (
    <Table className="w-full">
      <Thead>
        <Tr enableHover={false}>
          <Th className="px-2">Corridor Pair</Th>
          <Th className="px-2">Processor</Th>
          <Th className="px-2">Number of Transactions</Th>
          <Th className="px-2">Success Rate (%)</Th>
          <Th className="px-2">Average Time</Th>
        </Tr>
      </Thead>

      <TBody>
        {Object.values(groupedByCurrency[currency]).map((item, index) => (
          <SubCurrencyTRow item={item} key={index} />
        ))}
      </TBody>
    </Table>
  );
};

const SubCurrencyTRow = ({item}: {item: AfriexProcessorMetricsBucket}) => {
  const {
    corridor_pair,
    processor,
    total_no_txn_per_p_cp_pi,
    success_count,
    total_duration,
  } = item;

  const successRate =
    total_no_txn_per_p_cp_pi > 0
      ? (success_count / total_no_txn_per_p_cp_pi) * 100
      : 0;
  const avgTime = success_count > 0 ? total_duration / success_count : 0;

  return (
    <Tr>
      <Td className={`px-2 font-medium`}>{corridor_pair}</Td>
      <Td className={`px-2 font-medium`}>{processor}</Td>
      <Td className={`px-2 font-medium`}>{total_no_txn_per_p_cp_pi}</Td>
      <Td className={`px-2 font-medium`}>{successRate.toFixed(2)}</Td>
      <Td className={`px-2 font-medium`}>{formatTime(avgTime)}</Td>
    </Tr>
  );
};

export default SubCurrencyTable;
